

const staticText = {
  heading: 'Overview',
  charts: {
    apiRequestsOverTimeChart: {
      title: 'API requests over time',
      linkOut: 'logs',
    },
    connectedVehiclesOverTimeChart: {
      title: 'Connected vehicles over time',
      linkOut: 'vehicles',
    },
    top5MakesByConnectedVehiclesChart: {
      title: 'Top 5 makes',
      linkOut: 'vehicles',
    },
  },
  connectFunnel: {
    title: 'Vehicle connections conversion rate',
    linkOut: 'connect/insights',
  },
  widgets: {
    connectedVehicles: {
      title: 'Connected vehicles',
      // tooltip: '',
      label: 'Total connections',
    },
    activeVehiclesWoWChange: {
      title: 'Active vehicles',
      // tooltip: '',
    },
    newConnectionsWoWChange: {
      title: 'Net new connections',
      // tooltip: '',
    },
    apiRequests: {
      title: 'API requests',
      tooltip: 'Number of billable API requests made by your active vehicle',
      label: 'API requests',
    },
    didYouKnow: {
      title: '💡 Did you know?',
      inlineLink: applicationId => `You can add a logo to customize your Connect flow under |+|Connect > Customize@@/apps/${applicationId}/connect/customize|+|`,
    },
  },
  freePlanLimitReachedBanner: {
    title: 'You’ve reached your plan’s vehicle limit. Upgrade to unlock higher limits, data insights, and advanced features.',
    upgradeFeatures: [
      {
        icon: 'car',
        label: 'Access up to 100 vehicles',
      },
      {
        icon: 'calendar',
        label: '7 days of log data',
      },
      {
        icon: 'arrowUp',
        label: 'Advanced insights',
      },
    ],
    upgradeButton: {
      text: 'Upgrade',
      path: '/team/billing',
    },
  },
};

export default staticText;
